
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as form from "../form";
import * as listbox from "../listbox";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";
import * as grid from "../grid";

let _msg_notsaved = "";

let LABEL_YES = "";
let LABEL_NO = "";
let LABEL_DELETE = "";

function visibilityCalculateDDL(show: boolean): void {
    const ddl = $("#CalculateGroupID").data("kendoDropDownList");

    if (ddl != null && ddl != undefined) {
        main.setHideKendoUIFormItem4("CalculateGroupID", show);
    }
}

export function initialize(labelYes: string, labelNo: string, labelDelete: string): void {
    $(document)        
        .off("click.overviewAddScenario", "#PreComMsgScenarioGrid .k-grid-add")
        .on("click.overviewAddScenario", "#PreComMsgScenarioGrid .k-grid-add", function (e: JQuery.Event): void {
        addScenario();
    });

    LABEL_YES = labelYes;
    LABEL_NO = labelNo;
    LABEL_DELETE = labelDelete;

    grid.loadGridOptions("PreComMsgScenarioGrid");
}

export function initializeScenario(preComMsgScenarioId: number): void {
    $(document)        
        .off("click.overviewAddScenarioMsg", "#MsgScenarioMsgGrid .k-grid-add")
        .on("click.overviewAddScenarioMsg", "#MsgScenarioMsgGrid .k-grid-add", function (e: JQuery.Event): void {
            addScenarioMsg(preComMsgScenarioId);
    });
    grid.loadGridOptions("MsgScenarioMsgGrid");
}

export function initializeScenarioMsg(preComMsgScenarioMsgId: number): void {
    $(document)        
        .off("click.overviewAddScenarioMsgInfo", "#MsgScenarioMsgInfoGrid .k-grid-add")
        .on("click.overviewAddScenarioMsgInfo", "#MsgScenarioMsgInfoGrid .k-grid-add", function (e: JQuery.Event): void {
        addScenarioMsgInfo(preComMsgScenarioMsgId);
    });

    const cbLCD = $("#LCD").data("kendoCheckBox");
    if (cbLCD) {
        visibilityCalculateDDL(cbLCD.check());
    }
    grid.loadGridOptions("MsgScenarioMsgInfoGrid");
}

export function initializeScenarioMsgInfo(preComMsgScenarioMsgInfoId: number): void {
    $(document)        
        .off("click.overviewAddScenarioMsgInfoText", "#MsgScenarioMsgInfoTextGrid .k-grid-add")
        .on("click.overviewAddScenarioMsgInfoText", "#MsgScenarioMsgInfoTextGrid .k-grid-add", function (e: JQuery.Event): void {
        addScenarioMsgInfoText(preComMsgScenarioMsgInfoId);
    });
    grid.loadGridOptions("MsgScenarioMsgInfoTextGrid");
}

// Scenario

export function addScenario(): void {
    navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenario");
}

export function showScenario(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Show mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenario?preComMsgScenarioId=" + dataItem.PreComMsgScenarioID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editScenario(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenario?preComMsgScenarioId=" + dataItem.PreComMsgScenarioID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteScenario(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioGridVM;

    main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
        [{ text: LABEL_YES, action: function () { removeScenario(dataItem.PreComMsgScenarioID); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
}

export function removeScenario(preComMsgScenarioId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("PreComMsgScenario/DeleteScenario?preComMsgScenarioId=" + preComMsgScenarioId),
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("PreComMsgScenario/Overview");
        }
    });
}


// ScenarioMsg

export function addScenarioMsg(preComMsgScenarioId: number): void {
    navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenarioMsg?preComMsgScenarioId=" + preComMsgScenarioId);
}

export function showScenarioMsg(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Show mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenarioMsg?preComMsgScenarioMsgId=" + dataItem.PreComMsgScenarioMsgID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editScenarioMsg(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenarioMsg?preComMsgScenarioMsgId=" + dataItem.PreComMsgScenarioMsgID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteScenarioMsg(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgGridVM;

    main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
        [{ text: LABEL_YES, action: function () { removeScenarioMsg(dataItem.PreComMsgScenarioMsgID); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
}

export function removeScenarioMsg(preComMsgScenarioMsgId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("PreComMsgScenario/DeleteScenarioMsg?preComMsgScenarioMsgId=" + preComMsgScenarioMsgId),
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            $("#MsgScenarioMsgGrid").data("kendoGrid").dataSource.read();
        }
    });
}

export function LCDChanged(e: kendo.ui.CheckBoxEvent): void {
    visibilityCalculateDDL(e.sender.check());
}


// ScenarioMsgInfo

export function addScenarioMsgInfo(preComMsgScenarioMsgId: number): void {
    navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenarioMsgInfo?preComMsgScenarioMsgId=" + preComMsgScenarioMsgId);
}

export function showScenarioMsgInfo(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Show mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgInfoGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenarioMsgInfo?preComMsgScenarioMsgInfoId=" + dataItem.PreComMsgScenarioMsgInfoID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editScenarioMsgInfo(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Show mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgInfoGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenarioMsgInfo?preComMsgScenarioMsgInfoId=" + dataItem.PreComMsgScenarioMsgInfoID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteScenarioMsgInfo(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgInfoGridVM;

    main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
        [{ text: LABEL_YES, action: function () { removeScenarioMsgInfo(dataItem.PreComMsgScenarioMsgInfoID); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
}

export function removeScenarioMsgInfo(preComMsgScenarioMsgInfoId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("PreComMsgScenario/DeleteScenarioMsgInfo?preComMsgScenarioMsgInfoId=" + preComMsgScenarioMsgInfoId),
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            $("#MsgScenarioMsgInfoGrid").data("kendoGrid").dataSource.read();
        }
    });
}


// ScenarioMsgInfoText

export function addScenarioMsgInfoText(preComMsgScenarioMsgInfoId: number): void {
    navigation.navigateToSpecificUrl("PreComMsgScenario/AddScenarioMsgInfoText?preComMsgScenarioMsgInfoId=" + preComMsgScenarioMsgInfoId);
}

export function showScenarioMsgInfoText(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);
                                                                        
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgInfoTextGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/ShowScenarioMsgInfoText?preComMsgScenarioMsgInfoTextId=" + dataItem.PreComMsgScenarioMsgInfoTextID + "&breadcrumbLabel=" + dataItem.Text.slice(0, 15));
}

export function editScenarioMsgInfoText(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgInfoTextGridVM;
    navigation.navigateToSpecificUrl("PreComMsgScenario/EditScenarioMsgInfoText?preComMsgScenarioMsgInfoTextId=" + dataItem.PreComMsgScenarioMsgInfoTextID + "&breadcrumbLabel=" + dataItem.Text.slice(0, 15));
}

export function deleteScenarioMsgInfoText(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as PreComMsgScenarioMsgInfoTextGridVM;

    main.openActionsDialog(' ', LABEL_DELETE + " '" + dataItem.Label + "'",
        [{ text: LABEL_YES, action: function () { removeScenarioMsgInfoText(dataItem.PreComMsgScenarioMsgInfoTextID); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
}

export function removeScenarioMsgInfoText(preComMsgScenarioMsgInfoTextId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("PreComMsgScenario/DeleteScenarioMsgInfoText?preComMsgScenarioMsgInfoTextId=" + preComMsgScenarioMsgInfoTextId),
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            $("#MsgScenarioMsgInfoTextGrid").data("kendoGrid").dataSource.read();
        }
    });
}


//--- LR ------------------------------------------------------------//

export function LR_Initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Return label changed not saved
*/
export function LR_LDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

export function LR_rightClicked(): void {
    listbox.moveItems("PreComMsgScenarioMsg_CplNotSelected", "PreComMsgScenarioMsg_CplSelected", "#LR_Validation", LR_LDataChangedNotSavedYet());
}

export function LR_leftClicked(): void {
    listbox.moveItems("PreComMsgScenarioMsg_CplSelected", "PreComMsgScenarioMsg_CplNotSelected", "#LR_Validation", LR_LDataChangedNotSavedYet());
}

export function LR_SaveButtonClicked(preComMsgScenarioMsgId: number): void {
    const list = JSON.stringify($("#PreComMsgScenarioMsg_CplSelected").data("kendoListBox").dataItems());

    $.ajax({
        type: "POST",
        data:
        {
            preComMsgScenarioMsgId: preComMsgScenarioMsgId,
            assigned: list
        },
        url: appsettings.getUrl("PreComMsgScenario/LR_Submit"),
        success: function (responseData) {
            if (responseData != null && responseData != undefined) {
                form.showServerResponse("LRShowResponse", responseData, function () { });
            }
        }
    });
}
